define(["require", "exports", "tslib", "@arcgis/core/Color"], function (require, exports, tslib_1, Color_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ColourUtil = void 0;
    Color_1 = tslib_1.__importDefault(Color_1);
    class ColourUtil {
        static make(colour, alpha) {
            return new Color_1.default([colour.r, colour.g, colour.b, alpha]);
        }
        static shadeColorHex(colour, percent = 0) {
            if (!colour || colour.length !== 7) {
                throw new Error(`Invalid colour ${colour}`);
            }
            if (percent < -1 || percent > 1) {
                throw new Error(`Invalid percent ${percent}`);
            }
            const f = parseInt(colour.slice(1), 16);
            const t = percent < 0 ? 0 : 255;
            const p = percent < 0 ? percent * -1 : percent;
            const R = f >> 16;
            const G = (f >> 8) & 0x00ff;
            const B = f & 0x0000ff;
            return ("#" +
                (0x1000000 +
                    (Math.round((t - R) * p) + R) * 0x10000 +
                    (Math.round((t - G) * p) + G) * 0x100 +
                    (Math.round((t - B) * p) + B))
                    .toString(16)
                    .slice(1));
        }
    }
    exports.ColourUtil = ColourUtil;
    Object.defineProperty(ColourUtil, "Black", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Color_1.default("#000000")
    });
    Object.defineProperty(ColourUtil, "Blue", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Color_1.default("#4a8cf6")
    });
    Object.defineProperty(ColourUtil, "Cyan", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Color_1.default("#99FFFF")
    });
    Object.defineProperty(ColourUtil, "Red", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Color_1.default("#FF0000")
    });
    Object.defineProperty(ColourUtil, "White", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Color_1.default("#FFFFFF")
    });
    Object.defineProperty(ColourUtil, "Orange", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Color_1.default([255, 153, 0])
    });
    Object.defineProperty(ColourUtil, "Pink", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Color_1.default("#FF1493")
    });
    Object.defineProperty(ColourUtil, "Grey", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Color_1.default("#CCCCCC")
    });
    Object.defineProperty(ColourUtil, "DarkGrey", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: new Color_1.default("#666666")
    });
    Object.defineProperty(ColourUtil, "PrimaryActiveSelected", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ColourUtil.Cyan
    });
    Object.defineProperty(ColourUtil, "PrimaryActive", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ColourUtil.Blue
    });
    Object.defineProperty(ColourUtil, "PrimaryArchived", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ColourUtil.Grey
    });
    Object.defineProperty(ColourUtil, "Secondary", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ColourUtil.Pink
    });
});
